import { insertAndFocus } from 'common/Prose/utils/insertAndFocus'
import { distributeColumns } from 'common/Prose/Commands/table/mutation'
import { Fragment } from 'prosemirror-model'
import { type EditorView } from 'prosemirror-view'
import { type TableSize } from '../InsertButtons/InsertTableButton/InsertTableButton'

export const createTableNode = (view: EditorView, tableSize: TableSize) => {
  const cellAttrs = { cellHeight: '32px' }
  // create columns
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const columns = new Array(tableSize.columns).fill(view.state.schema.nodes.table_cell.createAndFill(cellAttrs)!)
  const columnsFragment = Fragment.fromArray(columns)

  // create rows
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const rowNode = view.state.schema.nodes.table_row.createAndFill({}, columnsFragment)!
  const rows = new Array(tableSize.rows).fill(rowNode)
  const rowsFragment = Fragment.fromArray(rows)

  // create and return table
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  return view.state.schema.nodes.table.createAndFill({}, rowsFragment)!
}

export const insertTable = (view: EditorView, tableSize: TableSize) => {
  const tableNode = createTableNode(view, tableSize)

  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const tableResolvedPos = insertAndFocus(view, tableNode)!
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const tableEl = view.nodeDOM(tableResolvedPos.pos)! as HTMLElement
  setTimeout(() => {
    distributeColumns(tableEl.offsetWidth, tableResolvedPos.pos)(view.state, view.dispatch)
  }, 0)
}
